/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPerspective = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.89 2.006a1 1 0 0 1 .327.018l9 2A1 1 0 0 1 22 5v10a1 1 0 0 1-.552.894l-12 6.012a1 1 0 0 1-1.313-.393L2.2 13.6A1 1 0 0 1 2 13V4a1 1 0 0 1 .89-.994zM10 19.392l10-5.01V6.18L10 7.847zM9.156 5.96l6.603-1.1-3.814-.848-5.469.608zM4 5.618v7.049L8 18V7.618z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPerspective as Perspective };
